// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Models/ModelModels.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { AIModel } from "./SettingsModels";

export const protobufPackage = "daisi.protos.v1";

export interface GetRequiredModelsRequest {
}

export interface GetRequiredModelsResponse {
  Models: AIModel[];
}

export interface CreateModelRequest {
  Model?: AIModel | undefined;
}

export interface CreateModelResponse {
  Model?: AIModel | undefined;
}

export interface GetModelRequest {
  Id: string;
}

export interface GetModelResponse {
  Model?: AIModel | undefined;
}

export interface GetAllModelsRequest {
}

export interface GetAllModelsResponse {
  Models: AIModel[];
}

export interface UpdateModelRequest {
  Model?: AIModel | undefined;
}

export interface UpdateModelResponse {
  Model?: AIModel | undefined;
}

export interface DeleteModelRequest {
  Id: string;
}

export interface DeleteModelResponse {
  Success: boolean;
}

function createBaseGetRequiredModelsRequest(): GetRequiredModelsRequest {
  return {};
}

export const GetRequiredModelsRequest: MessageFns<GetRequiredModelsRequest> = {
  encode(_: GetRequiredModelsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRequiredModelsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRequiredModelsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetRequiredModelsRequest {
    return {};
  },

  toJSON(_: GetRequiredModelsRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetRequiredModelsRequest>, I>>(base?: I): GetRequiredModelsRequest {
    return GetRequiredModelsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRequiredModelsRequest>, I>>(_: I): GetRequiredModelsRequest {
    const message = createBaseGetRequiredModelsRequest();
    return message;
  },
};

function createBaseGetRequiredModelsResponse(): GetRequiredModelsResponse {
  return { Models: [] };
}

export const GetRequiredModelsResponse: MessageFns<GetRequiredModelsResponse> = {
  encode(message: GetRequiredModelsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Models) {
      AIModel.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRequiredModelsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRequiredModelsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Models.push(AIModel.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRequiredModelsResponse {
    return {
      Models: globalThis.Array.isArray(object?.Models) ? object.Models.map((e: any) => AIModel.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetRequiredModelsResponse): unknown {
    const obj: any = {};
    if (message.Models?.length) {
      obj.Models = message.Models.map((e) => AIModel.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetRequiredModelsResponse>, I>>(base?: I): GetRequiredModelsResponse {
    return GetRequiredModelsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRequiredModelsResponse>, I>>(object: I): GetRequiredModelsResponse {
    const message = createBaseGetRequiredModelsResponse();
    message.Models = object.Models?.map((e) => AIModel.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCreateModelRequest(): CreateModelRequest {
  return { Model: undefined };
}

export const CreateModelRequest: MessageFns<CreateModelRequest> = {
  encode(message: CreateModelRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Model !== undefined) {
      AIModel.encode(message.Model, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateModelRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateModelRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Model = AIModel.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateModelRequest {
    return { Model: isSet(object.Model) ? AIModel.fromJSON(object.Model) : undefined };
  },

  toJSON(message: CreateModelRequest): unknown {
    const obj: any = {};
    if (message.Model !== undefined) {
      obj.Model = AIModel.toJSON(message.Model);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateModelRequest>, I>>(base?: I): CreateModelRequest {
    return CreateModelRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateModelRequest>, I>>(object: I): CreateModelRequest {
    const message = createBaseCreateModelRequest();
    message.Model = (object.Model !== undefined && object.Model !== null)
      ? AIModel.fromPartial(object.Model)
      : undefined;
    return message;
  },
};

function createBaseCreateModelResponse(): CreateModelResponse {
  return { Model: undefined };
}

export const CreateModelResponse: MessageFns<CreateModelResponse> = {
  encode(message: CreateModelResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Model !== undefined) {
      AIModel.encode(message.Model, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateModelResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateModelResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Model = AIModel.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateModelResponse {
    return { Model: isSet(object.Model) ? AIModel.fromJSON(object.Model) : undefined };
  },

  toJSON(message: CreateModelResponse): unknown {
    const obj: any = {};
    if (message.Model !== undefined) {
      obj.Model = AIModel.toJSON(message.Model);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateModelResponse>, I>>(base?: I): CreateModelResponse {
    return CreateModelResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateModelResponse>, I>>(object: I): CreateModelResponse {
    const message = createBaseCreateModelResponse();
    message.Model = (object.Model !== undefined && object.Model !== null)
      ? AIModel.fromPartial(object.Model)
      : undefined;
    return message;
  },
};

function createBaseGetModelRequest(): GetModelRequest {
  return { Id: "" };
}

export const GetModelRequest: MessageFns<GetModelRequest> = {
  encode(message: GetModelRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetModelRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetModelRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetModelRequest {
    return { Id: isSet(object.Id) ? globalThis.String(object.Id) : "" };
  },

  toJSON(message: GetModelRequest): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetModelRequest>, I>>(base?: I): GetModelRequest {
    return GetModelRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetModelRequest>, I>>(object: I): GetModelRequest {
    const message = createBaseGetModelRequest();
    message.Id = object.Id ?? "";
    return message;
  },
};

function createBaseGetModelResponse(): GetModelResponse {
  return { Model: undefined };
}

export const GetModelResponse: MessageFns<GetModelResponse> = {
  encode(message: GetModelResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Model !== undefined) {
      AIModel.encode(message.Model, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetModelResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetModelResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Model = AIModel.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetModelResponse {
    return { Model: isSet(object.Model) ? AIModel.fromJSON(object.Model) : undefined };
  },

  toJSON(message: GetModelResponse): unknown {
    const obj: any = {};
    if (message.Model !== undefined) {
      obj.Model = AIModel.toJSON(message.Model);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetModelResponse>, I>>(base?: I): GetModelResponse {
    return GetModelResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetModelResponse>, I>>(object: I): GetModelResponse {
    const message = createBaseGetModelResponse();
    message.Model = (object.Model !== undefined && object.Model !== null)
      ? AIModel.fromPartial(object.Model)
      : undefined;
    return message;
  },
};

function createBaseGetAllModelsRequest(): GetAllModelsRequest {
  return {};
}

export const GetAllModelsRequest: MessageFns<GetAllModelsRequest> = {
  encode(_: GetAllModelsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAllModelsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllModelsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetAllModelsRequest {
    return {};
  },

  toJSON(_: GetAllModelsRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllModelsRequest>, I>>(base?: I): GetAllModelsRequest {
    return GetAllModelsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllModelsRequest>, I>>(_: I): GetAllModelsRequest {
    const message = createBaseGetAllModelsRequest();
    return message;
  },
};

function createBaseGetAllModelsResponse(): GetAllModelsResponse {
  return { Models: [] };
}

export const GetAllModelsResponse: MessageFns<GetAllModelsResponse> = {
  encode(message: GetAllModelsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Models) {
      AIModel.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAllModelsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllModelsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Models.push(AIModel.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllModelsResponse {
    return {
      Models: globalThis.Array.isArray(object?.Models) ? object.Models.map((e: any) => AIModel.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetAllModelsResponse): unknown {
    const obj: any = {};
    if (message.Models?.length) {
      obj.Models = message.Models.map((e) => AIModel.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllModelsResponse>, I>>(base?: I): GetAllModelsResponse {
    return GetAllModelsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllModelsResponse>, I>>(object: I): GetAllModelsResponse {
    const message = createBaseGetAllModelsResponse();
    message.Models = object.Models?.map((e) => AIModel.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateModelRequest(): UpdateModelRequest {
  return { Model: undefined };
}

export const UpdateModelRequest: MessageFns<UpdateModelRequest> = {
  encode(message: UpdateModelRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Model !== undefined) {
      AIModel.encode(message.Model, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateModelRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateModelRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Model = AIModel.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateModelRequest {
    return { Model: isSet(object.Model) ? AIModel.fromJSON(object.Model) : undefined };
  },

  toJSON(message: UpdateModelRequest): unknown {
    const obj: any = {};
    if (message.Model !== undefined) {
      obj.Model = AIModel.toJSON(message.Model);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateModelRequest>, I>>(base?: I): UpdateModelRequest {
    return UpdateModelRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateModelRequest>, I>>(object: I): UpdateModelRequest {
    const message = createBaseUpdateModelRequest();
    message.Model = (object.Model !== undefined && object.Model !== null)
      ? AIModel.fromPartial(object.Model)
      : undefined;
    return message;
  },
};

function createBaseUpdateModelResponse(): UpdateModelResponse {
  return { Model: undefined };
}

export const UpdateModelResponse: MessageFns<UpdateModelResponse> = {
  encode(message: UpdateModelResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Model !== undefined) {
      AIModel.encode(message.Model, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateModelResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateModelResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Model = AIModel.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateModelResponse {
    return { Model: isSet(object.Model) ? AIModel.fromJSON(object.Model) : undefined };
  },

  toJSON(message: UpdateModelResponse): unknown {
    const obj: any = {};
    if (message.Model !== undefined) {
      obj.Model = AIModel.toJSON(message.Model);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateModelResponse>, I>>(base?: I): UpdateModelResponse {
    return UpdateModelResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateModelResponse>, I>>(object: I): UpdateModelResponse {
    const message = createBaseUpdateModelResponse();
    message.Model = (object.Model !== undefined && object.Model !== null)
      ? AIModel.fromPartial(object.Model)
      : undefined;
    return message;
  },
};

function createBaseDeleteModelRequest(): DeleteModelRequest {
  return { Id: "" };
}

export const DeleteModelRequest: MessageFns<DeleteModelRequest> = {
  encode(message: DeleteModelRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteModelRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteModelRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteModelRequest {
    return { Id: isSet(object.Id) ? globalThis.String(object.Id) : "" };
  },

  toJSON(message: DeleteModelRequest): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteModelRequest>, I>>(base?: I): DeleteModelRequest {
    return DeleteModelRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteModelRequest>, I>>(object: I): DeleteModelRequest {
    const message = createBaseDeleteModelRequest();
    message.Id = object.Id ?? "";
    return message;
  },
};

function createBaseDeleteModelResponse(): DeleteModelResponse {
  return { Success: false };
}

export const DeleteModelResponse: MessageFns<DeleteModelResponse> = {
  encode(message: DeleteModelResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteModelResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteModelResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteModelResponse {
    return { Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false };
  },

  toJSON(message: DeleteModelResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteModelResponse>, I>>(base?: I): DeleteModelResponse {
    return DeleteModelResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteModelResponse>, I>>(object: I): DeleteModelResponse {
    const message = createBaseDeleteModelResponse();
    message.Success = object.Success ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
